
(function loginDefinition() {
    'use strict';
    angular.module('Entities')
        .service('loginService', [
            'restUrlBuilder', 'config', '$injector', function loginService(restUrlBuilder, config, $injector) {
                restUrlBuilder = restUrlBuilder('auth');

                this.getById = function getById(id, forEdit) {
                    if (angular.isUndefined(forEdit)) {
                        forEdit = true;
                    }

                    return restUrlBuilder.one('logins', 'logged')
                        .get({
                            params: {
                                forEdit: forEdit
                            }
                        });
                };

                this.get = function get(nickName, name, lastName, organizationalUnitId, completeName, identifier) {

                    var params = { NickName: nickName, FirstName: name, LastName: lastName, OrganizationalUnitId: organizationalUnitId, FullName: completeName, Identifier: identifier };

                    return restUrlBuilder.all('logins')
                        .get({ params: params });

                };

                this.getLogged = function getLogged(profile) {
                    if (angular.isUndefined(profile)) {
                        profile = false;
                    }

                    return restUrlBuilder.one('logins', 'logged')
                        .get({
                            params: {
                                profile: profile
                            }
                        });
                };

                this.modify = function loginModify(login, profile) {
                    if (login == null)
                        throw "login no puede ser null";

                    return restUrlBuilder.all('logins')
                        .put(login);
                };

                this.modifyWithImage = function modifyWithImage(login, image) {
                    if (login == null)
                        throw "login no puede ser null";

                    var upload = $injector.get('Upload');

                    if (upload == null)
                        throw "No se pudo instanciar Upload. Verifique que se cargó el script ng-file-upload";

                    return upload.upload({
                        url: restUrlBuilder.all('logins/profile').url,
                        method: 'PUT',
                        fields: { login: JSON.stringify(login) },
                        file: [image],
                        fileFormDataName: 'imageFile'
                    });
                };

                this.setUser = function (userId) {
                    if (userId == null)
                        throw "UserId no puede ser null";

                    return restUrlBuilder.one('logins/SetUser', userId).put();
                };

                this.setUserOu = function (ou) {
                    return restUrlBuilder.one('logins/SetOu', ou).put();
                };
            }
        ]);
})();